import { UsersInterface } from '../../..';

export class SignInRequestDto implements UsersInterface {
  email: string;
  username?: string;
  password: string;
  adminApp?: boolean;
}
